<template>
  <div class="contractAward">
    <el-card>
      <el-form ref="filter" :model="filter" inline size="small" label-width="120px">
        <el-form-item label="班级名称" prop="skuName">
          <el-input v-model="filter.skuName" placeholder="班级名称" clearable />
        </el-form-item>
        <el-form-item label="当前学习状态" prop="userLearnStatus">
          <el-select v-model="filter.userLearnStatus" placeholder="当前学习状态" clearable>
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in xuexiStatus" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="学习落后百分比" prop="userBehindNum">
          <el-select v-model="filter.userBehindNumMin" style="width: 100px" clearable>
            <el-option v-for="(item, i) in 101" :key="item" :disabled="(filter.userBehindNumMax ? i > filter.userBehindNumMax : false) || filter.userBehindNumMax === 0" :label="i" :value="i"></el-option>
          </el-select>
          至
          <el-select v-model="filter.userBehindNumMax" style="width: 100px" clearable>
            <el-option v-for="(item, i) in 101" :key="item" :disabled="filter.userBehindNumMin ? i < filter.userBehindNumMin : false" :label="i" :value="i"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="当前学习阶段" prop="userLearnStage">
          <el-select v-model="filter.userLearnStage" placeholder="当前学习状态" clearable>
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in xuexiJieduan" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否已预约考试" prop="appointNum">
          <el-select v-model="filter.appointNum" placeholder="请选择是否已预约考试" clearable>
            <el-option label="全部" value="" />
            <el-option label="未预约" :value="0" />
            <el-option label="已预约" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="学员手机号" prop="phone">
          <el-input v-model="filter.phone" placeholder="学员手机号" clearable />
        </el-form-item>
        <el-form-item label="班级类型" prop="skuType">
          <el-select v-model="filter.skuType" placeholder="请选择班级类型" clearable>
            <el-option label="班级" value="1" />
            <el-option label="公开课" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="教务服务方名称" prop="agentName">
          <el-input v-model="filter.agentName" placeholder="请输入教务服务方名称"></el-input>
        </el-form-item>
        <el-form-item label="招生服务方名称" prop="distributName">
          <el-input v-model="filter.distributName" placeholder="请输入招生服务方名称"></el-input>
        </el-form-item>
        <el-form-item label-width="120px" label=" ">
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button size="small" @click="myReset(1)">重置</el-button>
        </el-form-item>
      </el-form>
      <el-row>
        <el-button type="primary" size="small" @click="handerCLick('luohouRemind')">落后提醒设置</el-button>
        <el-button type="primary" size="small" @click="handleExport">导出</el-button>
      </el-row>
    </el-card>
    <br>
    <el-table :data="tableData" border>
      <el-table-column align="center" label="序号" prop="id" min-width="180px" :formatter="fliteRData" />
      <el-table-column align="center" label="班级名称" prop="skuName" min-width="160px" :formatter="fliteRData" />
      <el-table-column align="center" label="班级类型" prop="skuType" min-width="120px">
        <template v-slot="{row}">
          {{row.skuType | skuTypeFilter()}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="昵称" prop="nickname" min-width="120px" :formatter="fliteRData" />
      <el-table-column align="center" label="学员姓名" prop="contractSignName" width="120">
        <template v-slot="{row}">
          {{ row.contractSignName || '--' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="教务服务方名称" prop="agentName" minWidth="120">
        <template v-slot="{row}">
          {{ row.agentName || '--' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="招生服务方名称" prop="distributName" minWidth="120">
        <template v-slot="{row}">
          {{ row.distributName || '--' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="学员手机号" prop="phone" min-width="120px">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="当前学习状态" prop="userLearnStatus" min-width="140px">
        <template slot="header">
          当前学习状态
          <el-tooltip class="item" effect="dark" content="仅统计基础必学课程与职业方向课程进度" placement="top">
            <span style="cursor: pointer;" class="el-icon-question"></span>
          </el-tooltip>
        </template>
        <template v-slot="{row}">
          <span v-if="row.skuType === 1">{{row.userLearnStatus | userLearnStatusFilter()}}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="当前学习阶段" prop="userLearnStage" min-width="120px">
        <template v-slot="{row}">
          <span v-if="row.skuType === 1">{{row.userLearnStage | userLearnStageFilter()}}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="班级看课总时长/h" prop="userSkuDuration" min-width="150px" :formatter="fliteRData">
        <template slot-scope="scope">
          <span v-if="scope.row.userSkuDuration">{{ (scope.row.userSkuDuration / 60 / 60).toFixed(2) }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="学习落后百分比" prop="userBehindNum" min-width="120px" :formatter="fliteRData">
        <template v-slot="{row}">
          <span v-if="row.skuType === 1">{{row.userBehindNum}}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="是否已预约考试" prop="userBehindNum" min-width="140px" :formatter="fliteRData">
        <template v-slot="{row}">
          <span v-if="row.appointNum === 0">未预约</span>
          <span v-else-if="row.appointNum && row.appointNum !== 0">已预约{{row.appointNum}}次</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="有效期开始时间" prop="beginDate" min-width="160px" :formatter="fliteRData" />
      <el-table-column align="center" label="有效期结束时间" prop="expiryDate" min-width="160px" :formatter="fliteRData" />
      <el-table-column align="center" label="操作" min-width="150px" fixed="right">
        <template v-slot="{ row }">
          <el-button v-if="$hasAuthority('app1_course_expiry_date') && row.skuType === 1" type="text" @click="handerCLick('edite',row)">修改有效期</el-button>
          <el-button v-if="$hasAuthority('app1_course_delete')" type="text" @click="handerCLick('delete',row)">删除</el-button>
          <el-button v-if="$hasAuthority('app1_course_delete_record')" type="text" @click="handerCLick('deleteRecord',row)">清除学习记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="pageSizes"
      :current-page="pageInfo.page"
      :page-size="pageInfo.limit"
      layout="total, sizes, prev, pager, next"
      :total="total"
    />
    <!-- 修改有效期 -->
    <modifyTimes ref="modifyTimes" @update="myReset(0)" />
    <!-- 落后提醒设置 -->
    <luohouRemind ref="luohouRemind" @update="myReset(0)" />
    <!-- 导出 -->
    <FileExport ref="FileExport" />
  </div>
</template>

<script>
import tableMoudel from "@/libs/mixins/table"
import modifyTimes from "./com/modifyTimes"
import luohouRemind from "./com/luohouRemind"
import FileExport from "@/components/FileExport.vue";
import { userSkupage } from "@/api/product/base"
import { getAppUserInfo } from "@/api/common";
import { delClassStudent, dealProgress } from "@/api/product/classManage"

const xuexiStatus = [
  { id: "", name: "全部" },
  { id: "1", name: "正常" },
  { id: "2", name: "落后" },
]

const skuTypeData = [
  { id: "1", name: "班级" },
  { id: "2", name: "公开课" },
]

const xuexiJieduan = [
  { id: "", name: "全部" },
  { id: "1", name: "基础必学课" },
  { id: "2", name: "职业方向课程" },
  { id: "3", name: "实操课程" },
]

export default {
  mixins: [tableMoudel],
  components: { modifyTimes, luohouRemind, FileExport },
  filters: {
    userLearnStageFilter (value) {
      const val = xuexiJieduan.find(item => item.id == value)
      return val ? val.name : '--'
    },
    userLearnStatusFilter (value) {
      const val = xuexiStatus.find(item => item.id == value)
      return val ? val.name : '--'
    },
    skuTypeFilter (value) {
      const val = skuTypeData.find(item => item.id == value)
      return val ? val.name : '--'
    }
  },
  data () {
    return {
      xuexiStatus,
      xuexiJieduan,
      skuTypeData,
      filter: {
        skuName:null,
        skuType: null,
        userLearnStatus:null,
        userBehindNum:null,
        userLearnStage:null,
        appointNum:'',
        phone:null,
        userBehindNumMin: null,
        userBehindNumMax: null,
        agentName: null,
        distributName: null,
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      console.log('获取数据')
      const params = {
        ...this.pageInfo,
        ...this.filter
      }
      const res = await userSkupage(params)
      const { records, total } = res.data
      this.total = Number(total)
      this.tableData = records.map(item => {
        delete item.sku.id
        return {
          ...item,
          ...item.sku
        }
      })
    },
    myReset(page) {
      this.filter.userBehindNumMin = ''
      this.filter.userBehindNumMax = ''
      if (page) {
        this.pageInfo.page = 1
      }
      this.reset('filter')
    },
    showDialog (name, item) {
      this.$refs[name].init(item)
    },
    handerCLick (event, item) {
      switch (event) {
        case 'edite':
          this.showDialog('modifyTimes', item)
          break;
        case 'delete':
          this.$confirm(`确认删除当前数据?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await delClassStudent({ id: item.id })
            if (res.code !== 0) {
              this.$message.error(res.message)
              return
            }
            this.$message.success('操作成功！')
            this.getData()
          })
          break;
        case 'deleteRecord':
          this.$confirm(`是否确认清除该学员学习记录?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await dealProgress({ userSkuId: item.id })
            if (res.code !== 0) {
              this.$message.error(res.message)
              return
            }
            this.$message.success('操作成功！')
            this.getData()
          })
          break;
        case 'luohouRemind':
          this.showDialog('luohouRemind', item)
          break
        default:
          break;
      }
    },
    // 导出
    handleExport() {
      this.$refs.FileExport.init(
        { ...this.filter }, // 搜索表单参数
        "jsw-product-provider", // 后端对应业务线服务
        "/adm/userSku/exportUserSkuData", // 导出-对应的接口
        1, //  状态：0get、1post
        "学员课程列表.xlsx" //文件名称
      );
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.tableData.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.more {
  margin-left: 10px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
